var map = {
	"./coupon_decorator.svg": 1095,
	"./dev/articles/article_placeholder--basic.png": 392,
	"./dev/articles/article_placeholder.png": 393,
	"./dev/banners/banner_placeholder--mobile.png": 394,
	"./dev/banners/banner_placeholder.png": 395,
	"./dev/banners/editor_banner.jpg": 396,
	"./dev/banners/galaxy-s20-fe_banner.jpg": 397,
	"./dev/banners/galaxy-tab-s7_banner.jpg": 398,
	"./dev/banners/nespresso_banner.png": 399,
	"./dev/banners/nespresso_banner_mobile.png": 400,
	"./dev/banners/nespresso_offer_banner.png": 401,
	"./dev/banners/offer_banner_placeholder.png": 402,
	"./dev/banners/product_category_banner-2.jpg": 403,
	"./dev/banners/product_category_banner.jpg": 404,
	"./dev/banners/samsung_banner.png": 405,
	"./dev/banners/samsung_banner_mobile.png": 406,
	"./dev/brand_logos/a4tech.png": 407,
	"./dev/brand_logos/amica.png": 408,
	"./dev/brand_logos/bissell.png": 409,
	"./dev/brand_logos/blaupunkt.png": 410,
	"./dev/brand_logos/bloody.png": 411,
	"./dev/brand_logos/braun.png": 412,
	"./dev/brand_logos/delonghi.png": 413,
	"./dev/brand_logos/hitachi.png": 414,
	"./dev/brand_logos/kenwood.png": 415,
	"./dev/brand_logos/navon.png": 416,
	"./dev/brand_logos/nintendo_switch.png": 417,
	"./dev/brand_logos/oral-b.png": 418,
	"./dev/brand_logos/panasonic.png": 419,
	"./dev/brand_logos/samsung-white.svg": 420,
	"./dev/brand_logos/samsung.png": 421,
	"./dev/brand_logos/samsung_basic.svg": 422,
	"./dev/brand_logos/xiaomi.png": 423,
	"./dev/carousel/slide_1.jpg": 424,
	"./dev/carousel/slide_3.jpg": 425,
	"./dev/editor/canvas-frame-lg.svg": 271,
	"./dev/editor/canvas-frame-md.svg": 272,
	"./dev/editor/canvas.svg": 273,
	"./dev/editor/editor_preview-1.webp": 274,
	"./dev/editor/editor_preview-2.webp": 275,
	"./dev/editor/editor_preview-3.webp": 276,
	"./dev/editor/editor_preview-4.webp": 277,
	"./dev/editor/editor_preview-5.webp": 278,
	"./dev/editor/editor_preview-map.webp": 279,
	"./dev/editor/editor_preview-star_map.webp": 280,
	"./dev/editor/frame-icon_1.png": 281,
	"./dev/editor/frame-icon_2.png": 282,
	"./dev/editor/frame-icon_3.png": 283,
	"./dev/editor/gallery_image-1.jpg": 284,
	"./dev/editor/gallery_image-2.jpg": 285,
	"./dev/editor/gallery_image-3.jpg": 286,
	"./dev/editor/gallery_image-4.jpg": 287,
	"./dev/editor/gallery_image-5.jpg": 288,
	"./dev/editor/horizontal-orientatio-icon.svg": 289,
	"./dev/editor/rigid-material.svg": 290,
	"./dev/editor/star-map-hero-sample-2.png": 291,
	"./dev/editor/star-map-hero-sample.png": 292,
	"./dev/editor/vertical-orientation-icon.svg": 293,
	"./dev/frames/frame_1.png": 302,
	"./dev/frames/frame_1.webp": 248,
	"./dev/frames/frame_2.png": 303,
	"./dev/frames/frame_2.webp": 249,
	"./dev/frames/frame_3.png": 304,
	"./dev/frames/frame_3.webp": 250,
	"./dev/product_banner.jpg": 426,
	"./dev/product_category_previews/product_category_preview-4.jpg": 427,
	"./dev/product_category_previews/product_category_preview_image-2.jpg": 428,
	"./dev/product_category_previews/product_category_preview_image-3.jpg": 429,
	"./dev/product_category_previews/product_category_preview_image-4.webp": 430,
	"./dev/product_category_previews/product_category_preview_image-5.webp": 305,
	"./dev/product_category_previews/product_category_preview_image-6-b.webp": 267,
	"./dev/product_category_previews/product_category_preview_image-6.webp": 431,
	"./dev/product_category_previews/product_category_preview_image-7.webp": 247,
	"./dev/product_category_previews/product_category_preview_image.jpg": 432,
	"./dev/products/feautured_product-placeholder.png": 433,
	"./dev/products/nespresso_limited_vertuo_next_black.jpg": 434,
	"./dev/products/nespresso_limited_vertuo_next_jade.jpg": 435,
	"./dev/products/product-placeholder-1.png": 436,
	"./dev/products/product-placeholder-10.png": 437,
	"./dev/products/product-placeholder-11.png": 438,
	"./dev/products/product-placeholder-12.png": 439,
	"./dev/products/product-placeholder-13.png": 440,
	"./dev/products/product-placeholder-14.png": 441,
	"./dev/products/product-placeholder-15.png": 442,
	"./dev/products/product-placeholder-16.png": 443,
	"./dev/products/product-placeholder-17.png": 444,
	"./dev/products/product-placeholder-18.png": 445,
	"./dev/products/product-placeholder-19.png": 446,
	"./dev/products/product-placeholder-2.png": 447,
	"./dev/products/product-placeholder-20.png": 448,
	"./dev/products/product-placeholder-21.png": 449,
	"./dev/products/product-placeholder-22.png": 450,
	"./dev/products/product-placeholder-23.png": 451,
	"./dev/products/product-placeholder-24.png": 452,
	"./dev/products/product-placeholder-25.png": 453,
	"./dev/products/product-placeholder-26.png": 454,
	"./dev/products/product-placeholder-27.png": 455,
	"./dev/products/product-placeholder-28.png": 456,
	"./dev/products/product-placeholder-29.png": 457,
	"./dev/products/product-placeholder-3.png": 458,
	"./dev/products/product-placeholder-30.png": 459,
	"./dev/products/product-placeholder-31.png": 460,
	"./dev/products/product-placeholder-32.png": 461,
	"./dev/products/product-placeholder-33.png": 462,
	"./dev/products/product-placeholder-34.png": 463,
	"./dev/products/product-placeholder-35.png": 464,
	"./dev/products/product-placeholder-36.png": 465,
	"./dev/products/product-placeholder-37.png": 466,
	"./dev/products/product-placeholder-38.png": 467,
	"./dev/products/product-placeholder-39.png": 468,
	"./dev/products/product-placeholder-4.png": 469,
	"./dev/products/product-placeholder-40.png": 470,
	"./dev/products/product-placeholder-41.png": 471,
	"./dev/products/product-placeholder-42.png": 472,
	"./dev/products/product-placeholder-43.png": 473,
	"./dev/products/product-placeholder-44.png": 474,
	"./dev/products/product-placeholder-45.png": 475,
	"./dev/products/product-placeholder-46.png": 476,
	"./dev/products/product-placeholder-47.png": 477,
	"./dev/products/product-placeholder-48.png": 478,
	"./dev/products/product-placeholder-49.png": 479,
	"./dev/products/product-placeholder-5.png": 480,
	"./dev/products/product-placeholder-50.png": 481,
	"./dev/products/product-placeholder-51.png": 482,
	"./dev/products/product-placeholder-52.png": 483,
	"./dev/products/product-placeholder-53.png": 484,
	"./dev/products/product-placeholder-54.png": 485,
	"./dev/products/product-placeholder-55.png": 486,
	"./dev/products/product-placeholder-56.png": 487,
	"./dev/products/product-placeholder-57.png": 488,
	"./dev/products/product-placeholder-58.png": 489,
	"./dev/products/product-placeholder-59.png": 490,
	"./dev/products/product-placeholder-6.png": 491,
	"./dev/products/product-placeholder-60.png": 492,
	"./dev/products/product-placeholder-61.png": 493,
	"./dev/products/product-placeholder-62.png": 494,
	"./dev/products/product-placeholder-63.png": 495,
	"./dev/products/product-placeholder-64.png": 496,
	"./dev/products/product-placeholder-65.png": 497,
	"./dev/products/product-placeholder-66.png": 498,
	"./dev/products/product-placeholder-67.png": 499,
	"./dev/products/product-placeholder-68.png": 500,
	"./dev/products/product-placeholder-69.png": 501,
	"./dev/products/product-placeholder-7.png": 502,
	"./dev/products/product-placeholder-70.png": 503,
	"./dev/products/product-placeholder-71.png": 504,
	"./dev/products/product-placeholder-72.png": 505,
	"./dev/products/product-placeholder-73.png": 506,
	"./dev/products/product-placeholder-74.png": 507,
	"./dev/products/product-placeholder-75.png": 508,
	"./dev/products/product-placeholder-76.png": 509,
	"./dev/products/product-placeholder-77.png": 510,
	"./dev/products/product-placeholder-78.png": 511,
	"./dev/products/product-placeholder-79.png": 512,
	"./dev/products/product-placeholder-8.png": 513,
	"./dev/products/product-placeholder-80.png": 514,
	"./dev/products/product-placeholder-81.png": 515,
	"./dev/products/product-placeholder-82.png": 516,
	"./dev/products/product-placeholder-83.png": 517,
	"./dev/products/product-placeholder-84.png": 518,
	"./dev/products/product-placeholder-85.png": 519,
	"./dev/products/product-placeholder-86.png": 520,
	"./dev/products/product-placeholder-87.png": 521,
	"./dev/products/product-placeholder-88.png": 522,
	"./dev/products/product-placeholder-89.png": 523,
	"./dev/products/product-placeholder-9.png": 524,
	"./dev/products/product-placeholder-90.png": 525,
	"./dev/products/product-placeholder-91.png": 526,
	"./dev/products/product-preview-1.png": 527,
	"./dev/products/product-preview-10.png": 528,
	"./dev/products/product-preview-11.png": 529,
	"./dev/products/product-preview-12.png": 530,
	"./dev/products/product-preview-13.png": 531,
	"./dev/products/product-preview-14.png": 532,
	"./dev/products/product-preview-15.png": 533,
	"./dev/products/product-preview-16.png": 534,
	"./dev/products/product-preview-17.png": 535,
	"./dev/products/product-preview-18.png": 536,
	"./dev/products/product-preview-19.png": 537,
	"./dev/products/product-preview-2.png": 538,
	"./dev/products/product-preview-20.png": 539,
	"./dev/products/product-preview-21.png": 540,
	"./dev/products/product-preview-22.png": 541,
	"./dev/products/product-preview-23.png": 542,
	"./dev/products/product-preview-24.png": 543,
	"./dev/products/product-preview-25.png": 544,
	"./dev/products/product-preview-26.png": 545,
	"./dev/products/product-preview-27.png": 546,
	"./dev/products/product-preview-28.png": 547,
	"./dev/products/product-preview-29.png": 548,
	"./dev/products/product-preview-3.png": 549,
	"./dev/products/product-preview-30.png": 550,
	"./dev/products/product-preview-31.png": 551,
	"./dev/products/product-preview-32.png": 552,
	"./dev/products/product-preview-33.png": 553,
	"./dev/products/product-preview-34.png": 554,
	"./dev/products/product-preview-35.png": 555,
	"./dev/products/product-preview-36.png": 556,
	"./dev/products/product-preview-37.png": 557,
	"./dev/products/product-preview-38.png": 558,
	"./dev/products/product-preview-39.png": 559,
	"./dev/products/product-preview-4.png": 560,
	"./dev/products/product-preview-40.png": 561,
	"./dev/products/product-preview-41.png": 562,
	"./dev/products/product-preview-42.png": 563,
	"./dev/products/product-preview-43.png": 564,
	"./dev/products/product-preview-44.png": 565,
	"./dev/products/product-preview-45.png": 566,
	"./dev/products/product-preview-46.png": 567,
	"./dev/products/product-preview-47.png": 568,
	"./dev/products/product-preview-48.png": 569,
	"./dev/products/product-preview-49.png": 570,
	"./dev/products/product-preview-5.png": 571,
	"./dev/products/product-preview-50.png": 572,
	"./dev/products/product-preview-51.png": 573,
	"./dev/products/product-preview-52.png": 574,
	"./dev/products/product-preview-53.png": 575,
	"./dev/products/product-preview-54.png": 576,
	"./dev/products/product-preview-55.png": 577,
	"./dev/products/product-preview-56.png": 578,
	"./dev/products/product-preview-57.png": 579,
	"./dev/products/product-preview-58.png": 580,
	"./dev/products/product-preview-59.png": 581,
	"./dev/products/product-preview-6.png": 582,
	"./dev/products/product-preview-60.png": 583,
	"./dev/products/product-preview-61.png": 584,
	"./dev/products/product-preview-62.png": 585,
	"./dev/products/product-preview-63.png": 586,
	"./dev/products/product-preview-64.png": 587,
	"./dev/products/product-preview-65.png": 588,
	"./dev/products/product-preview-66.png": 589,
	"./dev/products/product-preview-67.png": 590,
	"./dev/products/product-preview-68.png": 591,
	"./dev/products/product-preview-69.png": 592,
	"./dev/products/product-preview-7.png": 593,
	"./dev/products/product-preview-70.png": 594,
	"./dev/products/product-preview-71.png": 595,
	"./dev/products/product-preview-72.png": 596,
	"./dev/products/product-preview-73.png": 597,
	"./dev/products/product-preview-74.png": 598,
	"./dev/products/product-preview-75.png": 599,
	"./dev/products/product-preview-76.png": 600,
	"./dev/products/product-preview-77.png": 601,
	"./dev/products/product-preview-78.png": 602,
	"./dev/products/product-preview-79.png": 603,
	"./dev/products/product-preview-8.png": 604,
	"./dev/products/product-preview-80.png": 605,
	"./dev/products/product-preview-81.png": 606,
	"./dev/products/product-preview-82.png": 607,
	"./dev/products/product-preview-83.png": 608,
	"./dev/products/product-preview-84.png": 609,
	"./dev/products/product-preview-85.png": 610,
	"./dev/products/product-preview-86.png": 611,
	"./dev/products/product-preview-87.png": 612,
	"./dev/products/product-preview-88.png": 613,
	"./dev/products/product-preview-89.png": 614,
	"./dev/products/product-preview-9.png": 615,
	"./dev/products/product-preview-90.png": 616,
	"./dev/products/product-preview-91.png": 617,
	"./dev/products/product_accessory-2.png": 618,
	"./dev/products/product_accessory.png": 619,
	"./dev/products/product_placeholder--basic.png": 620,
	"./dev/products/product_placeholder.jpg": 621,
	"./dev/products/samsung-galaxy-book-s-2.jpg": 622,
	"./dev/products/samsung-galaxy-book-s-3.jpg": 623,
	"./dev/products/samsung-galaxy-book-s-4.jpg": 624,
	"./dev/products/samsung-galaxy-book-s-5.jpg": 625,
	"./dev/products/samsung-galaxy-book-s.jpg": 626,
	"./dev/products/samsung_QE55Q70AATXXH.jpg": 627,
	"./dev/products/samsung_a217f.jpg": 628,
	"./dev/products/samsung_as17f_purple.jpg": 629,
	"./dev/products/samsung_g991b.jpg": 630,
	"./dev/products/samsung_g998b.jpg": 631,
	"./dev/products/samsung_galaxy_book_s.jpg": 632,
	"./dev/products/samsung_galaxy_book_s.png": 633,
	"./dev/products/xbox_wireless_controller.jpg": 634,
	"./dev/products/xbox_wireless_headset.jpg": 635,
	"./dev/sample.jpg": 636,
	"./dev/star_map_editor/frame--horizontal.png": 251,
	"./dev/star_map_editor/frame_1.png": 252,
	"./dev/star_map_editor/frame_2.png": 253,
	"./dev/star_map_editor/frame_3.png": 254,
	"./dev/star_map_editor/shadow--horizontal.png": 255,
	"./dev/star_map_editor/shadow--horizontal.webp": 256,
	"./dev/star_map_editor/shadow.png": 257,
	"./dev/star_map_editor/shadow.webp": 258,
	"./dev/star_map_editor/star-map.svg": 259,
	"./dev/star_map_editor/star-map_bg-1.png": 260,
	"./dev/star_map_editor/star-map_bg-2.png": 261,
	"./dev/star_map_editor/star-map_bg-3.png": 262,
	"./dev/star_map_editor/star-map_bg-4.png": 263,
	"./dev/star_map_editor/star-map_bg-5.png": 264,
	"./dev/star_map_editor/star-map_black.png": 265,
	"./dev/star_map_editor/star-map_white.png": 266,
	"./editor_onboarding_illustrations/map-step_1.webp": 813,
	"./editor_onboarding_illustrations/map-step_2.webp": 814,
	"./editor_onboarding_illustrations/map-step_3.webp": 815,
	"./editor_onboarding_illustrations/map-step_4.webp": 816,
	"./editor_onboarding_illustrations/map-step_5.webp": 817,
	"./editor_onboarding_illustrations/map-step_6.webp": 818,
	"./editor_onboarding_illustrations/star-map-step_1.webp": 819,
	"./editor_onboarding_illustrations/star-map-step_2.webp": 820,
	"./editor_onboarding_illustrations/star-map-step_3.webp": 821,
	"./editor_onboarding_illustrations/star-map-step_4.webp": 822,
	"./editor_onboarding_illustrations/star-map-step_5.webp": 823,
	"./editors/frames/frame-black.webp": 824,
	"./editors/frames/frame-white.webp": 825,
	"./editors/frames/shadow.webp": 690,
	"./editors/star-map/themes/icons/black-circle.svg": 826,
	"./editors/star-map/themes/icons/black.svg": 827,
	"./editors/star-map/themes/icons/black_and_gold.svg": 828,
	"./editors/star-map/themes/icons/watercolor_black.svg": 829,
	"./editors/star-map/themes/icons/watercolor_white.svg": 830,
	"./editors/star-map/themes/icons/white-circle.svg": 831,
	"./editors/star-map/themes/icons/white.svg": 832,
	"./editors/star-map/themes/icons/white_and_gold.svg": 833,
	"./editors/star-map/themes/star-map_backgrounds-black.webp": 834,
	"./editors/star-map/themes/star-map_backgrounds-black_and_gold.webp": 835,
	"./editors/star-map/themes/star-map_backgrounds-black_circle.webp": 836,
	"./editors/star-map/themes/star-map_backgrounds-watercolor_black.webp": 837,
	"./editors/star-map/themes/star-map_backgrounds-watercolor_white.webp": 838,
	"./editors/star-map/themes/star-map_backgrounds-white.webp": 839,
	"./editors/star-map/themes/star-map_backgrounds-white_and_gold.webp": 840,
	"./editors/star-map/themes/star-map_backgrounds-white_circle.webp": 841,
	"./emojis/heart_emoji.png": 686,
	"./emojis/heart_eyes_emoji.png": 842,
	"./emojis/party_face_emoji.png": 687,
	"./emojis/sad_emoji.png": 680,
	"./emojis/slightly_smiling_emoji.png": 843,
	"./emojis/thumbs_up_emoji.png": 844,
	"./emojis/waving_hand_emoji.png": 845,
	"./error_bg.jpg": 1096,
	"./icons/active-star.svg": 698,
	"./icons/advantages-icon.svg": 691,
	"./icons/arrow-down-stroke-icon-red.svg": 699,
	"./icons/arrow-down-stroke-icon-white.svg": 700,
	"./icons/arrow-down-stroke-icon.svg": 701,
	"./icons/background_black-icon.svg": 702,
	"./icons/background_blue-icon.svg": 703,
	"./icons/background_white-icon.svg": 704,
	"./icons/background_yellow-icon.svg": 705,
	"./icons/blockquote-icon.svg": 706,
	"./icons/box-icon.svg": 707,
	"./icons/card-icon.svg": 708,
	"./icons/cart-icon--black.svg": 709,
	"./icons/cart-icon-stroke--white.svg": 710,
	"./icons/cart-icon-stroke.svg": 711,
	"./icons/cart-icon.svg": 712,
	"./icons/category-list-icon.svg": 713,
	"./icons/checkmark-icon--green.svg": 692,
	"./icons/checkmark-icon--white.svg": 714,
	"./icons/checkmark-icon-strong-black.svg": 715,
	"./icons/checkmark-icon-strong-white.svg": 716,
	"./icons/checkmark-icon.svg": 717,
	"./icons/chevron-down-white.svg": 718,
	"./icons/chevron-right-black.svg": 719,
	"./icons/chevron-right-white.svg": 720,
	"./icons/close-icon-black.svg": 721,
	"./icons/close-icon-fill.svg": 722,
	"./icons/close-icon-orange.svg": 723,
	"./icons/close-icon.svg": 724,
	"./icons/comparison-icon-blue.svg": 725,
	"./icons/comparison-icon.svg": 726,
	"./icons/cookie-icon.svg": 727,
	"./icons/devices-icon.svg": 728,
	"./icons/dislike-icon.svg": 729,
	"./icons/download-icon.svg": 730,
	"./icons/editor/material/canvas-frame-lg.svg": 731,
	"./icons/editor/material/canvas-frame-md.svg": 732,
	"./icons/editor/material/canvas.svg": 733,
	"./icons/editor/material/rigid-material.svg": 734,
	"./icons/editor/orientation/horizontal-orientatio-icon.svg": 735,
	"./icons/editor/orientation/vertical-orientation-icon.svg": 736,
	"./icons/error-icon.svg": 270,
	"./icons/facebook-icon-white.svg": 737,
	"./icons/facebook-icon.svg": 738,
	"./icons/flag-icon--en.svg": 739,
	"./icons/flag-icon--hu.svg": 740,
	"./icons/gallery-icon.svg": 688,
	"./icons/gls-icon.jpg": 741,
	"./icons/gls-pp-icon.jpg": 742,
	"./icons/half-active-star.svg": 743,
	"./icons/hearth-icon-black.svg": 744,
	"./icons/hearth-icon.svg": 745,
	"./icons/hearts-icon.svg": 746,
	"./icons/image-icon.svg": 689,
	"./icons/inactive-star.svg": 747,
	"./icons/info-fill-icon.svg": 693,
	"./icons/insta-icon-white.svg": 748,
	"./icons/insta-icon.svg": 749,
	"./icons/like-icon--red.svg": 750,
	"./icons/like-icon.svg": 751,
	"./icons/login-icon-white.svg": 752,
	"./icons/login-icon.svg": 753,
	"./icons/magnifier-icon-white.svg": 754,
	"./icons/magnifier-icon.svg": 755,
	"./icons/mail-icon.svg": 756,
	"./icons/marker--hearth-white-stroke.svg": 757,
	"./icons/marker--hearth-white.svg": 758,
	"./icons/marker--hearth.svg": 759,
	"./icons/marker--invisible-stroke.svg": 760,
	"./icons/marker--invisible.svg": 761,
	"./icons/marker--party-face.svg": 762,
	"./icons/marker--red.svg": 763,
	"./icons/marker--smile-hearth-eyes.svg": 764,
	"./icons/marker--smile.svg": 765,
	"./icons/marker--thumbs-up.svg": 766,
	"./icons/marker--yellow.svg": 767,
	"./icons/marker.svg": 768,
	"./icons/orders-icon.svg": 769,
	"./icons/paypal-icon.jpg": 770,
	"./icons/phone-icon.svg": 771,
	"./icons/plus-icon-blue.svg": 772,
	"./icons/plus-icon-red.svg": 773,
	"./icons/registration-icon-white.svg": 774,
	"./icons/registration-icon.svg": 775,
	"./icons/sad-icon.svg": 776,
	"./icons/shape_arch-icon.svg": 777,
	"./icons/shape_circle-icon.svg": 778,
	"./icons/shape_diamond-icon.svg": 779,
	"./icons/shape_heart-icon.svg": 780,
	"./icons/shape_hexagon-icon.svg": 781,
	"./icons/shape_octagon-icon.svg": 782,
	"./icons/shape_oval-icon.svg": 783,
	"./icons/shape_rectangle-icon.svg": 784,
	"./icons/shape_rosette-icon.svg": 785,
	"./icons/shape_rounded-icon.svg": 786,
	"./icons/shape_shield-icon.svg": 787,
	"./icons/shape_star-icon.svg": 788,
	"./icons/sheet-icon-white.svg": 789,
	"./icons/sheet-icon.svg": 790,
	"./icons/store-icon-white.svg": 791,
	"./icons/store-icon.svg": 792,
	"./icons/successful-icon.svg": 694,
	"./icons/transport-icon.svg": 793,
	"./icons/tweet-icon-white.svg": 794,
	"./icons/tweet-icon.svg": 795,
	"./icons/user-icon-white.svg": 796,
	"./icons/user-icon.svg": 797,
	"./icons/wallet-icon.svg": 798,
	"./icons/zoom-icon.svg": 799,
	"./logo--white.png": 1097,
	"./logo.png": 1098,
	"./logos/Barion-card-strip-intl_large.png": 1099,
	"./logos/accepted_card_logos.jpg": 1100,
	"./logos/accepted_card_logos.svg": 1101,
	"./logos/barion-card-strip-intl.svg": 695,
	"./logos/i18n.png": 1102,
	"./logos/kartapolis-white.svg": 846,
	"./logos/maestro.png": 1103,
	"./logos/mastercard.png": 1104,
	"./logos/miragejs.jpg": 1105,
	"./logos/nuxt-logo.png": 1106,
	"./logos/nuxt.jpg": 1107,
	"./logos/paypal.jpg": 1108,
	"./logos/primevue.jpg": 1109,
	"./logos/storybook.png": 1110,
	"./logos/tailwind.jpg": 1111,
	"./logos/visa.png": 1112,
	"./logos/vuex.png": 1113,
	"./logos/whispers_of_wood-white-logo.png": 847,
	"./map_styles/apple_maps.svg": 848,
	"./map_styles/aqua.svg": 849,
	"./map_styles/architecture.svg": 850,
	"./map_styles/assassins_creed.svg": 851,
	"./map_styles/avocado_world.svg": 852,
	"./map_styles/black.svg": 853,
	"./map_styles/blue.svg": 854,
	"./map_styles/blue_neon.svg": 855,
	"./map_styles/boston.svg": 856,
	"./map_styles/bright_colors.svg": 857,
	"./map_styles/classic.svg": 858,
	"./map_styles/dark.svg": 859,
	"./map_styles/dinosaur.svg": 860,
	"./map_styles/ease.svg": 861,
	"./map_styles/flat_map.svg": 862,
	"./map_styles/glow.svg": 863,
	"./map_styles/gray.svg": 864,
	"./map_styles/grayscale_style.svg": 865,
	"./map_styles/hoogeland.svg": 866,
	"./map_styles/hopper.svg": 867,
	"./map_styles/interface.svg": 868,
	"./map_styles/invert.svg": 869,
	"./map_styles/london.svg": 870,
	"./map_styles/mono.svg": 871,
	"./map_styles/navy_blue.svg": 872,
	"./map_styles/nightlife.svg": 873,
	"./map_styles/pale_dawn.svg": 874,
	"./map_styles/pedro.svg": 875,
	"./map_styles/red.svg": 876,
	"./map_styles/retro.svg": 877,
	"./map_styles/shades_of_grey.svg": 878,
	"./map_styles/singapore.svg": 879,
	"./map_styles/subtle_grayscale.svg": 880,
	"./map_styles/thin.svg": 881,
	"./map_styles/ultra_light_with_labels.svg": 882,
	"./map_styles/vector.svg": 883,
	"./map_styles/vibrant.svg": 884,
	"./map_styles/vintage.svg": 885,
	"./map_styles/vintage_golden_brown.svg": 886,
	"./map_styles/warm.svg": 887,
	"./map_styles/wy.svg": 888,
	"./shapes/shape_circle--black.png": 1114,
	"./shapes/shape_circle--black.webp": 1115,
	"./shapes/shape_circle--blue.png": 1116,
	"./shapes/shape_circle--blue.webp": 1117,
	"./shapes/shape_circle--yellow.png": 1118,
	"./shapes/shape_circle--yellow.webp": 1119,
	"./shapes/shape_circle.png": 1120,
	"./shapes/shape_circle.webp": 1121,
	"./shapes/shape_hearth--black.png": 1122,
	"./shapes/shape_hearth--black.webp": 1123,
	"./shapes/shape_hearth--blue.png": 1124,
	"./shapes/shape_hearth--blue.webp": 1125,
	"./shapes/shape_hearth--yellow.png": 1126,
	"./shapes/shape_hearth--yellow.webp": 1127,
	"./shapes/shape_hearth.png": 1128,
	"./shapes/shape_hearth.webp": 1129,
	"./shapes/shape_rectangle--black.png": 1130,
	"./shapes/shape_rectangle--black.webp": 1131,
	"./shapes/shape_rectangle--blue.png": 1132,
	"./shapes/shape_rectangle--blue.webp": 1133,
	"./shapes/shape_rectangle--yellow.png": 1134,
	"./shapes/shape_rectangle--yellow.webp": 1135,
	"./shapes/shape_rectangle.png": 1136,
	"./shapes/shape_rectangle.webp": 1137,
	"./whispers-of-wood/rose-colors/blue.webp": 681,
	"./whispers-of-wood/rose-colors/purple.webp": 682,
	"./whispers-of-wood/rose-colors/red.webp": 683,
	"./whispers-of-wood/rose-colors/turquoise.webp": 684,
	"./whispers-of-wood/whispers_of_wood-hero--mobile.webp": 889,
	"./whispers-of-wood/whispers_of_wood-hero-2.webp": 800,
	"./whispers-of-wood/whispers_of_wood-hero.webp": 890,
	"./whispers-of-wood/whispers_of_wood-hero_v2.webp": 891,
	"./whispers-of-wood/wine_holder_frame.webp": 801
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1094;